import { pyCallable, chainOrSuspend, pyStr, pyObject } from "@Sk";
import { funcFastCall } from "@runtime/runner/py-util";
import * as componentCreation from "@runtime/runner/component-creation";
import * as component from "@runtime/components/Component";

let formOpened = false;
let formEventHandlerEverCalled = false;
let componentEventSetterCalled = false;

export const onOpenedForm = () => { formOpened = true; };


const wrapFormEventHandler = (handler: pyCallable) => {
    return funcFastCall((args, kwargs) => {
        componentEventSetterCalled = false;
        return chainOrSuspend(handler.tp$call(args, kwargs), (returnValue) => {
            // Only do this part if the call completed successfully (didn't throw)
            if (formOpened && componentEventSetterCalled && !formEventHandlerEverCalled) {
                window.parent?.postMessage({
                    fn: "formEventHandlerCalled"
                }, window.anvilParams.ideOrigin!);
                formEventHandlerEverCalled = true;
            }
            return returnValue;
        });
    });
};

export const setUpInstrumentation = () => {
    if (window.anvilParams.instrumentFormEvents) {
        componentCreation.setInstrumentationHooks(wrapFormEventHandler);

        const tp$setattr = component.Component.prototype.tp$setattr;
        function tp$setattrWrapper() {
            componentEventSetterCalled = true;
            return tp$setattr.apply(this, arguments);
        }
        component.Component.prototype.tp$setattr = tp$setattrWrapper;

    }
};
